'use client';

import { useGtmTrack } from '../index';
import { ANALYTICS_EVENTS } from '../types';
import type { LeadGenerationInteractionProps, TrackingFunction } from '../types';
import { validateLeadGenerationEventData } from '../validation';

export const useLeadGenerationInteraction = (
  props: LeadGenerationInteractionProps,
  autoTrack: boolean = false,
): TrackingFunction => {
  const trackGtm = useGtmTrack(
    {
      eventName: ANALYTICS_EVENTS.LEAD_GENERATION_INTERACTION,
      properties: props,
    },
    autoTrack,
  );

  // Holds an unparsed value; the reader narrows it at the point of use.
  // oxlint-disable-next-line anti-slop/no-unsafe-dictionary-type
  const track = (eventProperties: Record<string, unknown> = {}, callback?: () => void) => {
    validateLeadGenerationEventData({ ...props, ...eventProperties });
    trackGtm(eventProperties, callback);
  };

  return track;
};
